import { createUseStyles } from "react-jss";
import Colours from "../../../../utils/colours";

const useStyles = createUseStyles((theme: any) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 10,
  },

  title: {
    size: 14,
    display: "flex",
  },

  subtitle: {
    size: 14,
    color: theme.grey.grey5,
    fontWeight: 500,
  },
}));

export default useStyles;
